import * as React from "react";
import { ThemeContext } from "react-ui";
import { OperationFailed, WidgetGenericFault } from "@skbkontur/loader-builder";

import {
    ContractorListOptions,
    GetContractorResponse,
    ImportContractorsWidgetOptions,
} from "../Types/ContractorsTypes";
import { useAsyncEffect } from "../../../../Common/UseAsyncEffect";
import { getCandyHub } from "../../Forms/Sentry/InitializeSentry";
import { reject } from "../../../../Common/TypingUtils";
import { GFV } from "../../../../Common/GFV";

export interface ContractorsSidePageProps {
    active: boolean;
    contractorsWidgetUrl: string;
    options?: ImportContractorsWidgetOptions;
    gfv: GFV;

    onSubmit: (contractors: GetContractorResponse[]) => void;
    onClose: () => void;
}

export const ContractorsSidePage = (props: ContractorsSidePageProps) => {
    if (!props.active || !props.options?.directoryId) {
        return null;
    }
    return <InteractiveSidePage {...props} />;
};

const InteractiveSidePage = (props: ContractorsSidePageProps) => {
    const candyCurrentTheme = React.useContext(ThemeContext);

    const handleWidgetResponseError = (widgetFailResponse: OperationFailed<WidgetGenericFault<string>>) => {
        const error = new Error(widgetFailResponse.fault.message);
        error.name = `ContractorsWidget dynamic import error: ${widgetFailResponse.fault.type}`;
        getCandyHub().captureException(error);
        // eslint-disable-next-line no-console
        console.error(error);
    };

    useAsyncEffect(async () => {
        const { importWidgetModule } = await import(
            /* webpackChunkName: "staffSelectorNpmLoader"*/ "@skbkontur/staff-selector-npm-loader"
        );

        const initResponse = await importWidgetModule({
            widgetUrl: `${props.contractorsWidgetUrl}/assets/StaffSelectorWidget/latest/loader.js`,
            dependencies: {
                productId: "keforms",
            },
        });

        if (initResponse.success) {
            const params: ContractorListOptions = {
                // @ts-ignore пропс удалили в новой версии, а пакет завязан на react-ui 4.15.6
                theme: candyCurrentTheme,
                blockBackground: true,
                ignoreBackgroundClick: true,
                listType: "contractor",
                onSubmit: ({ contractors }) => props.onSubmit(contractors),
                mode: props.options?.mode ?? "default",
                contractorOptions: {
                    directoryId: props.options?.directoryId ?? reject("directoryId is not defined"),
                },
                context: {
                    gfv: props.gfv,
                },
            };

            // @ts-ignore из-за разных версий staff-common в виджете и у нас
            const renderResponse = await initResponse.value.init(params);
            if (!renderResponse.success) {
                handleWidgetResponseError(renderResponse);
            }
        } else {
            handleWidgetResponseError(initResponse);
        }
    }, []);

    return null;
};
